import * as React from 'react';
import cn from 'classnames';

import Shimmer from '../Shimmer';

import styles from './StatsCountShimmer.module.scss';


export const StatsCountShimmer: React.FC<{}> = ({ ...rest }) => {
  return (
    <div className={cn([styles.StatsCountShimmer])} style={{width: '100%',borderRadius:"20px"}} >
      
      <div className={styles.titleWrapper}>
        
          <Shimmer w="80%" h={40} radius={3} />
          <Shimmer w="70%" h={25} radius={3} />
          <Shimmer w="40%" h={14} radius={3} />
        
      </div>
    </div>
  );
};

export default StatsCountShimmer;
